import { createRouter, createWebHistory } from 'vue-router';
import createMiddlewarePipeline from '@/router/createMiddlewarePipeline';
import { collectMatchedMiddleware } from '@/utils/router';
import routes from './routes';

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from) => {
  const middleware = collectMatchedMiddleware(to.matched);

  if (!middleware.length) {
    return true;
  }

  return createMiddlewarePipeline({ to, from }, middleware);
});

export default router;
